/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button } from "@nordcloud/gnui";
import { showSuccess } from "~/components/Toast";
import { generateActionSuccessText, useAxios } from "~/tools";
import { ServiceViewCtx } from "~/views/services/details/ServiceViewCtx";
import EditRequestSidebar from "./EditRequestSidebar";

export default function () {
  const { refetch } = React.useContext(ServiceViewCtx);

  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const { Axios } = useAxios();

  const addRequest = async (values: any) => {
    await Axios().post("/requests", values);
    showSuccess(
      generateActionSuccessText(`Request ${values.name}`)()("added")()
    );

    return refetch();
  };

  return (
    <>
      <Button
        onClick={() => setIsSidebarOpen(true)}
        size="md"
        css={{ marginLeft: "auto", marginBottom: "1rem" }}
        icon="plus"
      >
        Add new request
      </Button>

      <EditRequestSidebar
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        onSubmit={addRequest}
      />
    </>
  );
}
